import { api } from '@/services'

async function useBindClientCart(cartId: string, clientId: string) {
    var Response = null
    var Error = null
    var Loading = true

    const Controller = new AbortController()

    const bindCart = async () => {
        try {
            const resp = await api.post('/Cart/VincularCliente', null, {
                params: {
                    CheckoutId: cartId,
                    ClienteId: clientId
                },
                signal: Controller.signal
            })

            Response = resp.data
        } catch (error) {
            Error = [
                'Ocorreu um erro ao vincular o carrinho ao cliente.',
                error.message
            ]
        } finally {
            Loading = false
        }
    }

    await bindCart()

    Controller.abort()

    return [Response, Error, Loading]
}

export { useBindClientCart }
